import * as moment from 'moment';
import { filter } from 'rxjs/operators';

export function groupBy(arr: Array<any>, prop) {
  return (arr || []).reduce((groups, item) => {
    const val =
      item['properties'] !== undefined ? item['properties'][prop] : item[prop];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups;
  }, {});
}

export function hexToRgba(hex, alpha = 100) {
  if (!hex) {
    return [0, 0, 0, 0];
  }
  hex = hex.replace('#', '');
  const r = parseInt(
    hex.length === 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2),
    16
  );
  const g = parseInt(
    hex.length === 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4),
    16
  );
  const b = parseInt(
    hex.length === 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6),
    16
  );
  return [r, g, b, alpha * 2.54];
}

export function secondsToTime(e) {
  const duration = moment.duration(e, 'seconds');
  const h = ('0' + duration.hours()).slice(-2); // 1
  const m = ('0' + duration.minutes()).slice(-2); // 20
  const s = ('0' + duration.seconds()).slice(-2); // 25

  return h + 'h ' + m + 'm ' + s + 's';
}

export function secondsToTimeArray(e) {
  const duration = moment.duration(e, 'seconds');
  const h = ('0' + duration.hours()).slice(-2); // 1
  const m = ('0' + duration.minutes()).slice(-2); // 20
  const s = ('0' + duration.seconds()).slice(-2); // 25

  return [h, m, s];
}

export function formatDate(date, fromFormat, toFormat, locale) {
  return moment(date, fromFormat).locale(locale).format(toFormat);
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export class FilterSQL {
  constructor() {}

  public filterQuery(sql: string, filters: any) {
    let filteredSql = sql;
    let bypass = '';
    // Date filter
    let fromDate = `'${filters.fromDate.year}-${(
      '0' + filters.fromDate.month
    ).slice(-2)}-${('0' + filters.fromDate.day).slice(-2)}T`;
    let toDate = `'${filters.toDate.year}-${('0' + filters.toDate.month).slice(
      -2
    )}-${('0' + filters.toDate.day).slice(-2)}T`;
    // Hour filter
    if (filters.hour && filters.fromHour !== undefined && filters.toHour !== undefined) {
      fromDate += `${filters.fromHour}:00z'`;
      toDate += filters.toHour === '00:00'  ? `23:59:59z'` :  `${filters.toHour}:00z'`;
    } else {
      fromDate += `00:00:00z'`;
      toDate += `23:59:59z'`;
    }
    // tslint:disable
    // Filter by geometry
    if (filters.custom && filters.customBBOX.length > 6) {
      let polygon = '';
      filters.customBBOX.map((elem, idx) => {
        const separator = idx % 2 === 0 ? ' ' : ',';
        polygon += elem + separator;
      })

      filteredSql = filteredSql.replace(/S.FILTER_BBOX_WIDGETS/g, `ST_INTERSECTS(s.the_geom,ST_GeomFromText('POLYGON((${polygon.slice(0, -1)}))',4326))`);
      filteredSql = filteredSql.replace(/SP.FILTER_BBOX_WIDGETS/g, `ST_INTERSECTS(sp.the_geom,ST_GeomFromText('POLYGON((${polygon.slice(0, -1)}))',4326))`);
      filteredSql = filteredSql.replace(/FILTER_BBOX_WIDGETS/g, `ST_INTERSECTS(the_geom,ST_GeomFromText('POLYGON((${polygon.slice(0, -1)}))',4326))`);

      filteredSql = filteredSql.replace(/S.FILTER_BBOX/g, `ST_INTERSECTS(s.the_geom,ST_GeomFromText('POLYGON((${polygon.slice(0, -1)}))',4326))`);
      filteredSql = filteredSql.replace(/SP.FILTER_BBOX/g, `ST_INTERSECTS(sp.the_geom,ST_GeomFromText('POLYGON((${polygon.slice(0, -1)}))',4326))`);
      filteredSql = filteredSql.replace(/FILTER_BBOX/g, `ST_INTERSECTS(the_geom,ST_GeomFromText('POLYGON((${polygon.slice(0, -1)}))',4326))`);

    } else if (filters.bbox) {
      filteredSql = filteredSql.replace(/S.FILTER_BBOX_WIDGETS/g, `ST_INTERSECTS(s.the_geom,ST_MakeEnvelope(${filters.bbox.join()},4326))`);
      filteredSql = filteredSql.replace(/SP.FILTER_BBOX_WIDGETS/g, `ST_INTERSECTS(sp.the_geom,ST_MakeEnvelope(${filters.bbox.join()},4326))`);
      filteredSql = filteredSql.replace(/FILTER_BBOX_WIDGETS/g, `ST_INTERSECTS(the_geom,ST_MakeEnvelope(${filters.bbox.join()},4326))`);

      filteredSql = filteredSql.replace(/S.FILTER_BBOX/g,'TRUE').replace(/SP.FILTER_BBOX/g,'TRUE').replace(/FILTER_BBOX/g,'TRUE');
    } else {
      filteredSql = filteredSql.replace(/S.FILTER_BBOX_WIDGETS/g,'TRUE').replace(/SP.FILTER_BBOX_WIDGETS/g,'TRUE').replace(/FILTER_BBOX_WIDGETS/g,'TRUE');
      filteredSql = filteredSql.replace(/S.FILTER_BBOX/g,'TRUE').replace(/SP.FILTER_BBOX/g,'TRUE').replace(/FILTER_BBOX/g,'TRUE');
    }
    // tslint:enable
    // Bypass
    // tslint:disable
    if (filters.bypass) {
      bypass = '_rondas';
    }
    // tslint:enable
    filteredSql = filteredSql.replace(/FILTER_FROM/g, fromDate);
    filteredSql = filteredSql.replace(/FILTER_TO/g, toDate);
    filteredSql = filteredSql.replace(/BYPASS/g, bypass);
    filteredSql = filteredSql.replace(/FILTER_NTRAM/g, `${filters.ntram}`);
    filteredSql = filteredSql.replace(/&&/g, `%26%26`);

    return filteredSql.replace(/(\r\n|\n|\r)/gm, '');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/utils.ts